import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InitializeAppService } from './services/initialize-app.service';
import { LoaderComponent } from './shared/component/loader/loader.component';
import { TapToTopComponent } from './shared/component/tap-to-top/tap-to-top.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    LoaderComponent,
    TapToTopComponent,
  ],
  templateUrl: './app.component.html',
})
export class AppComponent {
  
  constructor(
    appService: InitializeAppService,
  ) {
    appService.initializeApp();
  }
}
